import { RouteRecordRaw } from 'vue-router';
import * as CONST from '@/const'

let routes: RouteRecordRaw[] = [
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import("./views/commessaDashboard.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.SuperAdmin, CONST.AppRoles.User, CONST.AppRoles.Guest],
            closeAppModal: true
        }
    },
];

export default routes;
